export const SyncOperation = { Create: 0, Update: 1, Delete: 2 } as const
export type SyncOperationType = typeof SyncOperation[keyof typeof SyncOperation]

export const SyncStatus = { Applied: 0, Conflict: 1, ShiftLocked: 2, NotFound: 3, Error: 4, NotPermitted: 5 } as const
export type SyncStatusType = typeof SyncStatus[keyof typeof SyncStatus]

export interface StoppageMutation {
  clientId: string
  operation: SyncOperationType
  stoppageId?: number
  rowVersion?: string
  shiftId: number
  data?: unknown
}

export interface LoadingMutation {
  clientId: string
  operation: SyncOperationType
  loadingId?: number
  rowVersion?: string
  shiftId: number
  data?: unknown
}

export interface DiggingPatternMutation {
  clientId: string
  operation: SyncOperationType
  diggingPatternId?: number
  rowVersion?: string
  shiftId: number
  data?: unknown
}

export interface PatternBlastMutation {
  clientId: string
  operation: SyncOperationType
  data: unknown
}

export interface CompleteShiftMutation {
  clientId: string
  shiftId: number
}

export interface GeoRehandleMutation {
  clientId: string
  operation: SyncOperationType
  geoRehandleId?: number
  rowVersion?: string
  shiftId?: number
  data?: unknown
}

export interface OperationLocationMutation {
  clientId: string
  operationId: number
  locationId: number
  shiftId?: number
  operationPlantId?: number
}

export interface EngineHoursMutation {
  clientId: string
  operationId: number
  shiftId: number
  startEngineHours?: number
  endEngineHours?: number
  fuel?: number
  operationPlantId?: number
}

export interface SyncRequest {
  patternBlasts: PatternBlastMutation[]
  diggingPatterns: DiggingPatternMutation[]
  loadings: LoadingMutation[]
  stoppages: StoppageMutation[]
  completeShifts: CompleteShiftMutation[]
  geoRehandles: GeoRehandleMutation[]
  operationLocations: OperationLocationMutation[]
  engineHours: EngineHoursMutation[]
}

export interface SyncMutationResult {
  clientId: string
  status: SyncStatusType
  serverId?: number
  serverState?: unknown
  serverRowVersion?: string
}

export interface SyncResponse {
  results: SyncMutationResult[]
}

export interface ClientSyncFailure {
  occurredAt: string
  clientId: string
  entity: string
  operation: string
  shiftId?: number
  httpStatus?: number
  outcome: string
  message?: string
  context: string
  payload: string
}
